import React from 'react';
import Responsive from 'react-responsive';

export const Wide = props => <Responsive {...props} minWidth={1400} />;
export const Desktop = props => <Responsive {...props} minWidth={1024} maxWidth={1399} />;
export const Tablet = props => <Responsive {...props} minWidth={746} maxWidth={1023} />;
export const Default = props => <Responsive {...props} minWidth={746} />;
export const Mobile = props => <Responsive {...props} maxWidth={745} />;


// WEBPACK FOOTER //
// ./src/js/components/Breakpoints/index.jsx